import React from 'react';
import { Image, Video, Mic, Camera, Upload } from 'lucide-react';

const MEDIA_TABS = [
  { key: 'image', label: 'Photo', icon: Image, color: '#D4AF37' },
  // Video + Audio upload paths removed per product decision —
  // photo-only vibes for the 8 category icons.
];

export const MediaSelector = ({
  mediaType, onMediaTypeChange,
  onFileChange, onCapturePhoto, onStartVideoRecording, onStartAudioRecording,
}) => {
  const activeTab = MEDIA_TABS.find((t) => t.key === mediaType);
  const acceptMap = { image: 'image/*', video: 'video/*', audio: 'audio/*' };

  return (
    <div className="flex-1 flex flex-col p-5 gap-5">
      <div className="flex gap-2 justify-center" data-testid="media-type-tabs">
        {MEDIA_TABS.map((tab) => {
          const Icon = tab.icon;
          const active = mediaType === tab.key;
          return (
            <button key={tab.key} onClick={() => onMediaTypeChange(tab.key)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full font-['Outfit'] text-sm font-semibold transition-all duration-300 ${
                active ? 'text-black shadow-[0_0_15px_rgba(212,175,55,0.2)]' : 'border border-white/10 text-white/40'
              }`}
              style={active ? { background: tab.color } : {}}
              data-testid={`media-tab-${tab.key}`}>
              <Icon size={16} />{tab.label}
            </button>
          );
        })}
      </div>

      <div className="flex flex-col items-center gap-4 py-4">
        <div className="w-16 h-16 rounded-full flex items-center justify-center border border-[#D4AF37]/20" style={{ background: activeTab.color, boxShadow: `0 0 20px ${activeTab.color}40` }}>
          {mediaType === 'image' && <Image size={28} className="text-black" />}
          {mediaType === 'video' && <Video size={28} className="text-white" />}
          {mediaType === 'audio' && <Mic size={28} className="text-black" />}
        </div>

        <label htmlFor="vibe-file-input"
          className="cursor-pointer w-full text-center px-6 py-3 bg-[#D4AF37] text-black rounded-full font-['Outfit'] font-semibold hover:shadow-[0_0_15px_rgba(212,175,55,0.3)] transition-all"
          data-testid="select-file-button">
          <Upload size={16} className="inline mr-2" />
          {mediaType === 'image' ? 'Choose from Gallery' : mediaType === 'video' ? 'Choose Video File' : 'Choose Audio File'}
        </label>
        <input id="vibe-file-input" type="file" accept={acceptMap[mediaType]} onChange={onFileChange} className="hidden" multiple data-testid="upload-file-input" />

        {mediaType === 'image' && (
          <button onClick={onCapturePhoto}
            className="w-full text-center px-6 py-3 rounded-full font-['Outfit'] font-medium transition-all border"
            style={{ borderColor: `${activeTab.color}50`, color: activeTab.color }}
            data-testid="capture-photo-button">
            <Camera size={16} className="inline mr-2" />Take Photo
          </button>
        )}
        {mediaType === 'video' && (
          <button onClick={onStartVideoRecording}
            className="w-full text-center px-6 py-3 rounded-full font-['Outfit'] font-medium transition-all border"
            style={{ borderColor: `${activeTab.color}50`, color: activeTab.color }}
            data-testid="record-video-button">
            <Camera size={16} className="inline mr-2" />Record Video
          </button>
        )}
        {mediaType === 'audio' && (
          <button onClick={onStartAudioRecording}
            className="w-full text-center px-6 py-3 rounded-full font-['Outfit'] font-medium transition-all border"
            style={{ borderColor: `${activeTab.color}50`, color: activeTab.color }}
            data-testid="record-audio-button">
            <Mic size={16} className="inline mr-2" />Record Audio
          </button>
        )}
      </div>
    </div>
  );
};

export { MEDIA_TABS };
